import React, { useState, useEffect, Fragment } from "react";
import { CircularProgress } from "@material-ui/core";
import { KeyboardArrowRight, MoreHoriz } from "@material-ui/icons";

import "./styles.scss";
import FirstStationTitle from "../FirstStationTitle";
import StationTitle from "../StationTitle";
import { langStringConvertor } from "../../utils/utils";
import Constants from "../../utils/constants";
import Pillar from "../../components/Pillar";
import contrastTest from "../../utils/contrastTest";

const { LANGUAGES } = Constants;
const { start, end } = LANGUAGES;

const SmallEtaCard = (props) => {
  const {
    origin,
    destination,
    stations,
    redirect,
    eta,
    displayType,
    court,
    routeCode,
    color,
    themeColour,
    showLicensePlate,
    vehicleLocations
  } = props;
  const firstStation = stations[0];
  const lastStation =
    displayType === "combineStops"
      ? stations[stations.length - 2] // get first route last stop
      : stations[stations.length - 1];

  const [language, setLanguage] = useState(props.language);

  useEffect(() => {
    setLanguage(props.language);
  }, [props.language]);

  const getTitle = (type) => {
    const allStopsFormat = () => {
      return stations.map((station, index) => {
        const stationEta = eta?.eta.find((el) => el.stopSeq === index + 1);

        //if firstEta is realtime 0mins, then use the second one
        const isFirstEtaRealtime =
          index === 0 &&
          stationEta?.eta?.[0]?.diff === 0 &&
          !stationEta?.eta?.[0]?.remarks_en;

        return (
          <StationTitle
            key={`${station.name_tc}${index}`}
            title={station[`name_${langStringConvertor(language)}`]}
            time={
              isFirstEtaRealtime
                ? stationEta?.eta?.[1]?.diff
                : stationEta?.eta?.[0]?.diff
            }
            timestamp={
              isFirstEtaRealtime
                ? stationEta?.eta?.[1]?.timestamp
                : stationEta?.eta?.[0]?.timestamp
            }
            remarks={
              isFirstEtaRealtime
                ? stationEta?.eta?.[1]?.[
                    `remarks_${langStringConvertor(language)}`
                  ]
                : stationEta?.eta?.[0]?.[
                    `remarks_${langStringConvertor(language)}`
                  ]
            }
            index={index}
            isLastStation={index === stations.length - 1}
            notes={station.type ? station.type[language] : null}
            language={language}
            court={court}
            color={color || themeColour}
            showLicensePlate={showLicensePlate}
            vehicleLocations={vehicleLocations}
          />
        );
      });
    };
    const result = {
      allStops: () => {
        return allStopsFormat();
      },
      firstStop: () => {
        const stationEta = eta?.eta.find((el) => el.stopSeq === 1);

        //if firstEta is realtime 0mins, then use the second one
        const isFirstEtaRealtime =
          stationEta?.eta?.[0]?.diff === 0 && !stationEta?.eta?.[0]?.remarks_en;

        return (
          <FirstStationTitle
            time={
              isFirstEtaRealtime
                ? stationEta?.eta?.[1]?.diff
                : stationEta?.eta?.[0]?.diff
            }
            timestamp={
              isFirstEtaRealtime
                ? stationEta?.eta?.[1]?.timestamp
                : stationEta?.eta?.[0]?.timestamp
            }
            remarks={
              isFirstEtaRealtime
                ? stationEta?.eta?.[1]?.[
                    `remarks_${langStringConvertor(language)}`
                  ]
                : stationEta?.eta?.[0]?.[
                    `remarks_${langStringConvertor(language)}`
                  ]
            }
            language={language}
            color={color}
          />
        );
      },
      ra: () => {
        return <></>;
      },
      noStop: () => {
        return <></>;
      },
      noETA: () => {
        return <></>;
      },
      combineStops: () => {
        return allStopsFormat();
      },
      headTailStops: () => {
        return stations.map((station, index) => {
          if (stations.length > 3) {
            if (index !== stations.length - 1 && index !== 0) {
              if (index === 2) {
                return (
                  <div className="station-title-container" key={index}>
                    <div className="dot-container">
                      <div className={`dot`}>
                        <Pillar position={"middle"} color={color || themeColour} />
                      </div>
                      <MoreHoriz
                        style={{ marginLeft: "10px", color: "#4F4F4F" }}
                      />
                    </div>
                  </div>
                );
              } else {
                return <Fragment key={index}></Fragment>;
              }
            }
          }
          const stationEta = eta?.eta.find((el) => el.stopSeq === index + 1);
          const isLastStation = index === stations.length - 1;

          //if firstEta is realtime 0mins, then use the second one
          const isFirstEtaRealtime =
            index === 0 &&
            stationEta?.eta?.[0]?.diff === 0 &&
            !stationEta?.eta?.[0]?.remarks_en;

          return (
            <StationTitle
              key={`${station.name_tc}${index}`}
              title={station[`name_${langStringConvertor(language)}`]}
              time={
                isFirstEtaRealtime
                  ? stationEta?.eta?.[1]?.diff
                  : stationEta?.eta?.[0]?.diff
              }
              timestamp={
                isFirstEtaRealtime
                  ? stationEta?.eta?.[1]?.timestamp
                  : stationEta?.eta?.[0]?.timestamp
              }
              remarks={
                isFirstEtaRealtime
                  ? stationEta?.eta?.[1]?.[
                      `remarks_${langStringConvertor(language)}`
                    ]
                  : stationEta?.eta?.[0]?.[
                      `remarks_${langStringConvertor(language)}`
                    ]
              }
              index={index}
              isLastStation={isLastStation}
              notes={
                index === 0
                  ? start[language]
                  : isLastStation
                  ? end[language]
                  : null
              }
              language={language}
              court={court}
              color={color}
              themeColour={themeColour}
              showLicensePlate={showLicensePlate}
              vehicleLocations={vehicleLocations}
            />
          );
        });
      },
      default: () => {
        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="progress-container"
          >
            <CircularProgress color="primary" />
          </div>
        );
      },
    };
    return type ? result[type]() : result["default"]();
  };

  return (
    <div className="small-eta-card" onClick={redirect}>
      <div className="title">
        <span
          className={language}
          style={{
            ...(color && {
              backgroundColor: color,
              color: "white",
              padding: 8,
              margin: -8,
              borderRadius: 10,
            }),
          }}
        >
          {language === "zh" || language === "cn"
            ? displayType === "combineStops"
              ? `${routeCode ? routeCode : ""}來往 ${destination}`
              : `${routeCode ? routeCode : ""}由 ${origin} 往 ${destination}`
            : displayType === "combineStops"
            ? `${routeCode ? routeCode : ""}To ${destination}`
            : `${routeCode ? routeCode : ""}From ${origin} 
          To ${destination}`}
        </span>
        <span className="click-arrow">
          <KeyboardArrowRight style={{ fontSize: 24 }} />
        </span>
      </div>
      <div className="content">{eta && getTitle(displayType)}</div>
    </div>
  );
};

export default SmallEtaCard;
